<template>
  <el-dialog
    :title="
      isEditDialog
        ? $t('dialog.titleRoomServiceGroupAdd')
        : $t('dialog.titleRoomServiceGroupAdd')
    "
    :visible="isShow"
    :close-on-click-modal="false"
    width="600px"
    @close="onClose"
  >
    <div class="das-form-container">
      <validation-observer ref="formValidator">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.groupCode') }}
                </div>
                <validation-provider
                  rules="required|max:20|no_special"
                  :name="$t('field.groupCode')"
                >
                  <input
                    v-model="formData.code"
                    type="text"
                    :readonly="isEditDialog"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.groupName') }}
                </div>
                <validation-provider
                  rules="required|max:100"
                  :name="$t('field.groupName')"
                >
                  <input v-model="formData.name" type="text" />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.transaction') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.transaction')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'description']"
                    :selected-index-field-value="formData.transaction_id"
                    :rows="transactionOptions"
                    :columns="transactionOptionsCols"
                    :value="formData.transaction_id"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectTransaction"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span
                          v-if="selectedData?.code && selectedData?.description"
                        >
                          {{ selectedData.code }} -
                          {{ selectedData.description }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.subTransaction') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.subTransaction')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'description']"
                    :selected-index-field-value="formData.sub_transaction_id"
                    :rows="subTransactionOptions"
                    :columns="subTransactionOptionsCols"
                    :value="formData.sub_transaction_id"
                    :dropdown-width="400"
                    :disabled="!formData.transaction_id"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectSubTransaction"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span
                          v-if="selectedData?.code && selectedData?.description"
                        >
                          {{ selectedData.code }} -
                          {{ selectedData.description }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.defaultTransactionPage') }}
                </div>
                <validation-provider
                  rules=""
                  :name="$t('field.defaultTransactionPage')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'desc']"
                    :selected-index-field-value="
                      formData.default_transaction_page
                    "
                    :rows="transactionPageOptions"
                    :columns="transactionPageOptionsCols"
                    :value="formData.default_transaction_page"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectTransPage"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span v-if="selectedData?.code && selectedData?.desc">
                          {{ selectedData.code }} -
                          {{ selectedData.desc }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>

            <div class="das-form-col col-6 flex align-end">
              <div class="das-form-input">
                <div class="checkbox-container" style="gap: 10px">
                  <div class="checkbox-wrap">
                    <input
                      id="tax_fee"
                      v-model="formData.tax_fee"
                      type="checkbox"
                    />
                    <label for="tax_fee">
                      {{ $t('field.includeTaxFee') }}
                    </label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="active"
                      v-model="formData.active"
                      type="checkbox"
                    />
                    <label for="active">
                      {{ $t('field.active') }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button
          v-if="isEditDialog"
          class="btn primary small"
          @click="updateRoomServiceGroup"
        >
          {{ $t('button.update') }}
        </button>
        <button v-else class="btn primary small" @click="addRoomServiceGroup">
          {{ $t('button.create') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { getTransPageListApi } from '@/api/common/code'
import { getTransactionListApi } from '@/api/Transaction/transaction'
import { getSubTransactionListApi } from '@/api/Transaction/subTransaction'
import {
  addRoomServiceGroupApi,
  updateRoomServiceGroupApi
} from '@/api/Service_Policy/roomServiceGroup'

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    isEditDialog: {
      type: Boolean,
      required: true
    },
    roomServiceGroup: Object
  },
  data() {
    return {
      formData: {
        code: null,
        name: null,
        transaction_id: null,
        sub_transaction_id: null,
        default_transaction_page: null,
        tax_fee: true,
        active: true
      },

      // SELECT OPTIONS
      transactionOptions: [],
      subTransactionOptions: [],
      transactionPageOptions: [],

      transactionOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          flex: 1,
          tooltipField: 'description',
          sortable: false

          // cellClass: "grid-cell-centered",
        }
      ],
      subTransactionOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          flex: 1,
          tooltipField: 'description',
          sortable: false

          // cellClass: "grid-cell-centered",
        }
      ],
      transactionPageOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          flex: 1,
          tooltipField: 'desc',
          sortable: false

          // cellClass: "grid-cell-centered",
        }
      ]
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.roomServiceGroup && this.isEditDialog) {
            this.formData = { ...this.roomServiceGroup }
            this.getSubTranSactionOptions(this.roomServiceGroup.transaction_id)
          }
        } else {
          setTimeout(() => {
            this.resetDialog()
          }, 500)
        }
      }
    }
  },
  beforeMount() {
    Promise.all([
      this.getTransactionOptions(),
      this.getTransactionPageOptions()
    ])
  },
  methods: {
    // SELECT OPTIONS
    async getTransactionOptions() {
      getTransactionListApi({ transactionGroup: 1 }).then(res => {
        this.transactionOptions = res.data
      })
    },
    async getSubTranSactionOptions(transactionId) {
      if (transactionId) {
        getSubTransactionListApi({
          transactionId: transactionId
        }).then(res => {
          this.subTransactionOptions = res.data
        })
      } else {
        this.subTransactionOptions = []
      }
    },
    async getTransactionPageOptions() {
      getTransPageListApi({ transactionGroup: 1 }).then(res => {
        this.transactionPageOptions = res.data
      })
    },

    onSelectTransaction(data) {
      if (data?.id !== null && data?.id !== undefined) {
        if (this.formData.transaction_id !== data.id) {
          this.formData.sub_transaction_id = null
        }
      } else {
        this.subTransactionOptions = []
        this.formData.sub_transaction_id = null
      }
      this.formData.transaction_id = data?.id ?? null
      this.getSubTranSactionOptions(data.id)
    },
    onSelectSubTransaction(data) {
      this.formData.sub_transaction_id = data?.id ?? null
    },
    onSelectTransPage(data) {
      this.formData.default_transaction_page = data?.id
    },

    resetDialog() {
      this.formData = {
        code: null,
        name: null,
        transaction_id: null,
        sub_transaction_id: null,
        default_transaction_page: null,
        tax_fee: true,
        active: true
      }

      this.subTransactionOptions = []
    },

    // ACTIONS
    async addRoomServiceGroup() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      addRoomServiceGroupApi(this.formData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('refreshData')
          this.$emit('close')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async updateRoomServiceGroup() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      updateRoomServiceGroupApi(this.formData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('refreshData')
          this.$emit('close')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style></style>
